import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import { buildDemoFinalizedReviewItems } from "../../utils/demoLiveTrainingReview";
import { getExerciseSequenceName } from "../../utils/liveTrainingSequenceAutoeval";
import { resolveExerciseDisplayName } from "../../utils/evaluationVideoMediaMeta";

function chipLabel(item, lang, t) {
  const order = item.teOrder != null ? `#${item.teOrder}` : "";
  const name = resolveExerciseDisplayName(item.exercise, t) || "";
  const shortName = name.length > 22 ? `${name.slice(0, 20)}…` : name;
  if (item.sequenceOrder == null) {
    return [order, shortName].filter(Boolean).join(" · ") || order || t("exercise", "Exercise");
  }
  const seqName = getExerciseSequenceName(
    item.exercise?.sequences?.find(
      (s) => s.sequence_order === item.sequenceOrder
    ),
    item.exercise,
    lang
  );
  const seqBit = seqName
    ? `${t("liveTrainingSequence", "Sequence")} ${item.sequenceOrder} · ${seqName}`
    : `${t("liveTrainingSequence", "Sequence")} ${item.sequenceOrder}`;
  return [order, seqBit].filter(Boolean).join(" · ");
}

export function DemoFinalizedReviewStrip({
  exercises = [],
  realtimeByTeId = {},
  currentTeId = null,
  currentSequenceIndexByTeId = {},
  awaitingManualSequenceStart = false,
  awaitingAutoSequenceStart = false,
  lastSequenceCompleted = false,
  onSelect,
}) {
  const { t, i18n } = useTranslation();
  const lang = String(i18n.language || "en").split("-")[0];
  const items = useMemo(
    () =>
      buildDemoFinalizedReviewItems(exercises, {
        realtimeByTeId,
        currentTeId,
        currentSequenceIndexByTeId,
        awaitingManualSequenceStart,
        awaitingAutoSequenceStart,
        lastSequenceCompleted,
      }),
    [
      exercises,
      realtimeByTeId,
      currentTeId,
      currentSequenceIndexByTeId,
      awaitingManualSequenceStart,
      awaitingAutoSequenceStart,
      lastSequenceCompleted,
    ]
  );

  if (!items.length || typeof onSelect !== "function") return null;

  return (
    <div className="lt-demo-review" role="region" aria-label={t("demoReviewFinalizedTitle")}>
      <div className="lt-demo-review__label">{t("demoReviewFinalizedTitle")}</div>
      <div className="lt-demo-review__chips">
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            className="lt-demo-review__chip"
            onClick={() => onSelect(item)}
            title={t("demoReviewFinalizedHint")}
          >
            <PlayCircleFilledIcon style={{ fontSize: 16 }} aria-hidden />
            <span>{chipLabel(item, lang, t)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default DemoFinalizedReviewStrip;
